import { Nullable } from "../base-types";
import { CultureLoadOption, ICultureLoadOption } from "../contracts/querying/culture-load-option";
import CultureInfo from "../culture-info";

// TODO: complete this class
export class MappingUtilities {
    //#region Dates

    static toNullableDate(dateTime?: Date): Nullable<Date> {
        return dateTime ?? null;
    }

    //#endregion

    static culturesToLoadOption(cultures: Array<CultureInfo>): ICultureLoadOption {
        if (cultures == null || cultures.length === 0) {
            return CultureLoadOption.None.deepClone();
        }

        return new CultureLoadOption(cultures);
    }
}
